import axios from 'axios';

// Read backend URL from environment
const backendUrl = process.env.REACT_APP_BACKEND_URL;

// Ensure API endpoint is consistent
// If backendUrl ends with "/api", don't add another "/api"
const API_URL = backendUrl.endsWith('/api')
  ? `${backendUrl}/protocols`
  : `${backendUrl}/api/protocols`;

const protocolService = {
  // Get all protocols
  getProtocols: async () => {
    const response = await axios.get(API_URL);
    return response.data;
  },

  // Get protocol by ID
  getProtocol: async (id) => {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  },

  // Create new protocol
  createProtocol: async (protocolData) => {
    const response = await axios.post(API_URL, protocolData);
    return response.data;
  },

  // Update protocol
  updateProtocol: async (id, protocolData) => {
    const response = await axios.put(`${API_URL}/${id}`, protocolData);
    return response.data;
  },

  // Delete protocol
  deleteProtocol: async (id) => {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  }
};

export default protocolService;
